
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Employeetransportserviceinpune() {



    const cardData =
    {
        keyword: 'Employee Transport Services in Pune',
        heading: 'etravo : Employee Transport Services in Pune',
        headingDescription: 'eTravo offers professional Employee Transport Services in Pune, specially designed to meet the mobility needs of companies, IT parks, manufacturing units, and business hubs across the city. Whether it’s daily staff pick-up and drop, shift-based transportation, or contract-based corporate travel, we ensure timely and hassle-free commuting solutions. Our fleet includes AC sedans, SUVs, and well-maintained buses equipped with GPS tracking, real-time monitoring, and experienced drivers. With a commitment to safety, punctuality, and operational excellence, eTravo helps businesses in Pune streamline employee transportation with ease and efficiency.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



   "services": [
  {
    "name": "Employee Transport Services in Pune",
    "description": "eTravo simplifies daily commutes with reliable employee transport services in Pune. Covering major residential and commercial zones, our buses and cabs ensure safe, punctual, and hassle-free travel for your workforce."
  },
  {
    "name": "Corporate Staff Transport Pune",
    "description": "eTravo offers efficient staff transportation solutions tailored for corporate clients in Pune. With a modern fleet and experienced drivers, we help optimize commuting while boosting employee productivity and satisfaction."
  },
  {
    "name": "AC Bus Hire for Employees Pune",
    "description": "Ensure your team travels in comfort with eTravo’s AC bus hire services in Pune. Ideal for daily office commutes, project site visits, or bulk staff transportation with climate-controlled vehicles and professional service."
  },
  {
    "name": "Car Rental Service in Pune for Corporates",
    "description": "eTravo provides corporate car rental services in Pune for business executives and employees. Choose from a premium fleet for meetings, airport transfers, or flexible daily use — all with expert chauffeurs."
  },
  {
    "name": "Best Employee Transportation Companies in Pune",
    "description": "Ranked among the best, eTravo delivers dependable and scalable employee transportation services in Pune. We focus on safety, efficiency, and satisfaction with every ride, no matter your company’s size."
  },
  {
    "name": "Affordable Employee Transportation Pune",
    "description": "eTravo’s affordable employee transportation in Pune helps businesses reduce travel costs while ensuring high service standards. Ideal for startups to enterprises looking for economical commuting solutions."
  },
  {
    "name": "Customized Mobility Plans for Employees Pune",
    "description": "eTravo creates tailored employee mobility plans in Pune to match your organization’s unique travel patterns. From flexible shift-based routes to integrated tracking, our services adapt to your needs."
  },
  {
    "name": "End-to-End Corporate Mobility Solutions Pune",
    "description": "From planning to execution, eTravo offers end-to-end corporate mobility solutions in Pune. Our services span daily commutes, events, and executive travel, all managed under one streamlined system."
  },
  {
    "name": "Executive Cab and Bus Services Pune",
    "description": "Travel smart with eTravo’s executive cab and bus services in Pune. Designed for top-tier corporate clients, our fleet offers luxury, punctuality, and privacy for every business journey."
  },
  {
    "name": "Staff Pickup and Drop Services Pune",
    "description": "eTravo’s staff pickup and drop services in Pune ensure reliable commuting for your employees. With real-time tracking and optimized routing, we provide peace of mind and timely arrivals every day."
  },
  {
    "name": "Reliable Corporate Commute Pune",
    "description": "Choose eTravo for reliable corporate commute services in Pune. Our commitment to timely service, safety standards, and employee satisfaction sets us apart as your trusted mobility partner."
  },
  {
    "name": "Business Transport Solutions Pune",
    "description": "eTravo delivers comprehensive business transport solutions in Pune, covering daily employee movement, executive transfers, and event logistics to support seamless corporate operations."
  },
  {
    "name": "Corporate Shuttle Services Pune",
    "description": "eTravo’s corporate shuttle services in Pune offer dedicated routes and schedules for smooth intra-city employee transport. Perfect for IT parks, industrial zones, and corporate hubs."
  },
  {
    "name": "Employee Commute Management Pune",
    "description": "Manage employee commutes efficiently with eTravo’s end-to-end platform in Pune. We handle scheduling, routing, tracking, and compliance to reduce admin overhead and improve efficiency."
  },
  {
    "name": "Staff Mobility Solutions Pune",
    "description": "eTravo delivers comprehensive staff mobility solutions in Pune, tailored to meet the needs of growing companies. From flexible shift coverage to 24/7 transport, we’ve got it covered."
  }
],
"tableData": [
  ["Employee Transport Services in Pune", "Corporate Staff Transport Pune"],
  ["AC Bus Hire for Employees Pune", "Car Rental Service in Pune for Corporates"],
  ["Best Employee Transportation Companies in Pune", "Affordable Employee Transportation Pune"],
  ["Customized Mobility Plans for Employees Pune", "End-to-End Corporate Mobility Solutions Pune"],
  ["Executive Cab and Bus Services Pune", "Staff Pickup and Drop Services Pune"],
  ["Reliable Corporate Commute Pune", "Business Transport Solutions Pune"],
  ["Corporate Shuttle Services Pune", "Employee Commute Management Pune"],
  ["Staff Mobility Solutions Pune", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Efficient Employee Transport Services in Pune",
        "WhyChoosedescription": "Pune’s dynamic mix of IT parks, educational hubs, and manufacturing zones demands reliable workforce mobility—and eTravo delivers. From Hinjewadi to Kharadi and beyond, our services ensure your employees reach work safely and on time, every day."
    },
    {
        "WhyChooseheading": "Customized Fleet for Pune’s Corporate Landscape",
        "WhyChoosedescription": "Whether your team needs hatchbacks, sedans, tempo travellers, or AC buses, our Pune fleet is equipped to handle businesses of all sizes. Our well-maintained vehicles support daily commutes, inter-campus travel, and client visits with equal ease."
    },
    {
        "WhyChooseheading": "Shift-Friendly Operations for IT and BPOs",
        "WhyChoosedescription": "With Pune’s many shift-based companies in areas like Magarpatta and Baner, we provide 24/7 transport schedules tailored to your business hours. Our round-the-clock cab and bus services help avoid employee delays and keep operations running smoothly."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
        "WhyChoosedescription": "Our drivers are trained, verified, and familiar with Pune’s key zones such as Hadapsar, Pimpri-Chinchwad, and Viman Nagar. Their professionalism ensures safe, courteous rides and optimal route planning for minimal travel disruptions."
    },
    {
        "WhyChooseheading": "Corporate Billing and Transparent Pricing",
        "WhyChoosedescription": "eTravo’s pricing model is designed for ease and clarity. From GST-compliant invoicing to detailed monthly statements, we offer complete financial transparency with no hidden charges—ideal for your finance and HR teams."
    },
    {
        "WhyChooseheading": "Safety, Hygiene, and Compliance Standards",
        "WhyChoosedescription": "All vehicles undergo routine sanitation and are fitted with GPS tracking, seat belts, first aid kits, and fire safety tools. We prioritize your employees’ safety and comfort throughout every ride."
    },
    {
        "WhyChooseheading": "Live Ride Tracking and 24/7 Assistance",
        "WhyChoosedescription": "Stay in control with real-time ride tracking and responsive customer support. Our Pune operations team is always on standby to handle urgent requests, rescheduling, or coordination with your admin teams."
    },
    {
        "WhyChooseheading": "Tailored Solutions for Pune-Based Companies",
        "WhyChoosedescription": "Whether you're a tech startup in Kalyani Nagar or a large manufacturer in Chakan, eTravo crafts transport packages that match your exact operational scale and structure—from long-term employee commutes to temporary project-based shuttles."
    }
]






































    }

const faqData = [
    [
        {
            question: 'What employee transport services does eTravo offer in Pune?',
            answer: 'eTravo provides reliable and efficient employee transport services in Pune, including shuttle services for IT parks, industrial zones, and corporate offices, supporting multiple shifts and optimized routes for timely commute.',
        },
        {
            question: 'Can eTravo handle multi-shift employee transport in Pune?',
            answer: 'Yes, eTravo offers structured employee transport solutions in Pune that cater to multiple shifts, ensuring smooth pick-up and drop timings with minimal wait times and maximum convenience.',
        },
        {
            question: 'What vehicle options are available for employee transport in Pune?',
            answer: 'Our fleet in Pune includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses (13–50 seaters), suitable for small groups to large teams, all maintained for comfort and safety.',
        },
        {
            question: 'Does eTravo provide real-time tracking and safety for employee transport in Pune?',
            answer: 'Absolutely. All vehicles used for employee transport in Pune are equipped with GPS tracking, driver verification, digital logs, and route compliance to ensure employee safety and timely travel.',
        },
        {
            question: 'Is there dedicated support for corporate employee transport in Pune?',
            answer: 'Yes, eTravo assigns a dedicated account manager for each corporate client in Pune to manage scheduling, address concerns, and provide ongoing support for employee transport services.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Deshmukh',
        designation: 'HR Manager, TechWave Solutions, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s employee transport services in Pune have been exceptional. The buses run on time, and the support team is very responsive. It’s a reliable solution for our daily workforce commute.”',
    },
    {
        name: 'Ms. Sneha Kulkarni',
        designation: 'Operations Head, Greenfield Industries, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for employee transport across multiple shifts in Pune. Their GPS tracking and punctuality give us great confidence in their services.”',
    },
];












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Employee Transport Services in Pune",
  "image": "https://www.etravo.in/images/keyword/employee-transport-pune.jpg",
  "description": "Reliable and affordable employee transport services in Pune including corporate staff transport, AC bus hire, car rental for corporates, customized mobility plans, and end-to-end corporate mobility solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/employee-transport-services-in-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Employee Transport Services in Pune | Corporate Staff Transport & Mobility Solutions | eTravo</title>
  <meta 
    name="description" 
    content="Reliable and affordable employee transport services in Pune by eTravo. Corporate staff transport, AC bus hire, executive cabs, and customized mobility plans for efficient business commute." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/4.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Employeetransportserviceinpune;